import React, { useEffect, useState } from "react";
import { DEFAULT_BASE_URL } from "../services/pdfService";
import "./ClientThumb.css";

const ClientThumb = React.memo(({ clientName, getApiToken, size = 20 }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let revoked = false;
    const name = (clientName || "").trim().toLowerCase();
    if (!name) return;

    (async () => {
      try {
        const token = await getApiToken();
        const res = await fetch(
          `${DEFAULT_BASE_URL}/clients/${encodeURIComponent(name)}/logo?t=${Date.now()}`,
          { headers: { Authorization: `Bearer ${token}` }, cache: "no-store" }
        );
        if (res.ok && !revoked) {
          setSrc(URL.createObjectURL(await res.blob()));
        }
      } catch {
        /* no logo available */
      }
    })();

    return () => { revoked = true; };
  }, [clientName, getApiToken]);

  if (!src) return null;

  return (
    <img
      className="client-thumb"
      src={src}
      alt=""
      style={{ width: size, height: size }}
    />
  );
});

ClientThumb.displayName = "ClientThumb";
export default ClientThumb;
